import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from '../i18n'
import { apiFetch } from '../utils/api'
import SEO from '../components/SEO'
import './AuthPages.css'

function ForgotPasswordPage() {
  const { t } = useTranslation()

  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)
  const [error, setError] = useState('')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      await apiFetch('/auth/forgot-password', {
        method: 'POST',
        body: JSON.stringify({ email }),
      })
      setSent(true)
    } catch {
      // Always show success to avoid leaking account existence,
      // but if the request itself fails (network error), show a generic error.
      setSent(true)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="auth-page">
      <SEO
        title="Forgot Password"
        description="Reset your Intervio account password."
        path="/forgot-password"
        noIndex
      />
      <div className="auth-card">
        <h1>{t('forgotPasswordTitle')}</h1>
        <p className="auth-subtitle">{t('forgotPasswordSubtitle')}</p>

        {sent ? (
          <>
            <div className="auth-success">{t('forgotPasswordSuccess')}</div>
            <p className="auth-switch" style={{ marginTop: '1.5rem' }}>
              <Link to="/login">{t('forgotPasswordBackToLogin')}</Link>
            </p>
          </>
        ) : (
          <>
            <form onSubmit={handleSubmit} className="auth-form">
              <div className="form-group">
                <label htmlFor="forgot-email">{t('authEmail')}</label>
                <input
                  id="forgot-email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder={t('authEmailPlaceholder')}
                  required
                  autoFocus
                />
              </div>

              {error && <div className="auth-error">{error}</div>}

              <button
                type="submit"
                className="btn btn-primary btn-large auth-submit"
                disabled={loading}
              >
                {loading ? t('forgotPasswordSending') : t('forgotPasswordButton')}
              </button>
            </form>

            <p className="auth-switch">
              <Link to="/login">{t('forgotPasswordBackToLogin')}</Link>
            </p>
          </>
        )}
      </div>
    </div>
  )
}

export default ForgotPasswordPage
